import React from 'react'
import clsx from 'clsx'

import RuangGTKHeader from 'app/RuangGTKHomepageV3/components/Header'
import PageContainer from 'app/DocumentCollectionPage/components/PageContainer'
import DocumentBreadcrumb from 'app/DocumentCollectionPage/components/DocumentBreadcrumb'

export type { BreadcrumbItemDef } from 'app/DocumentCollectionPage/components/DocumentBreadcrumb'
import type { BreadcrumbItemDef } from 'app/DocumentCollectionPage/components/DocumentBreadcrumb'

type NavLink = {
  label: string
  href: string
  external?: boolean
}

interface DesktopPageHeaderProps {
  breadcrumbItems?: BreadcrumbItemDef[]
  /** Tailwind classes applied to the breadcrumb bar wrapper (background, border, etc.) */
  breadcrumbClassName?: string
  /** Tailwind classes applied to the breadcrumb text — use to override text color on coloured backgrounds */
  breadcrumbTextClassName?: string
  navLinks?: NavLink[]
  bottomBar?: React.ReactNode
}

const DesktopPageHeader = ({
  breadcrumbItems,
  breadcrumbClassName,
  breadcrumbTextClassName,
  navLinks,
  bottomBar,
}: DesktopPageHeaderProps) => (
  <div className="sticky top-0 z-50 shrink-0 bg-white">
    <RuangGTKHeader showSearch={false} navLinks={navLinks} />
    {breadcrumbItems && breadcrumbItems.length > 0 && (
      <div className={clsx('border-b', breadcrumbClassName ?? 'bg-white')}>
        <PageContainer className="!py-2 !pt-1">
          <DocumentBreadcrumb
            items={[{ label: 'Beranda', href: '/' }, ...breadcrumbItems]}
            className={breadcrumbTextClassName}
          />
        </PageContainer>
      </div>
    )}
    {bottomBar}
  </div>
)

export default DesktopPageHeader
